import { render, staticRenderFns } from "./CompanyDetailModal.vue?vue&type=template&id=64c955d4&"
import script from "./CompanyDetailModal.vue?vue&type=script&lang=js&"
export * from "./CompanyDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports